import React, { Suspense, useEffect, useState } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  CardMedia,
  CircularProgress,
  Container,
  Grid,
  Typography,
} from "@mui/material";
import { HashLink } from "react-router-hash-link";
import { useParams } from "react-router-dom";
import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import useData from "../../../Hooks/useData";
import { SERVICE_COMPONENTS } from "../ServiceContent";
import { Helmet } from "react-helmet-async";

const ServiceDetails = () => {
  const { slug } = useParams();
  const [service, setService] = useState(null);
  const services = useData();

  const ServiceComponent =
    service?.component && SERVICE_COMPONENTS[service.component];

  useEffect(() => {
    if (services.length > 0) {
      const found = services.find((s) => s.slug === slug);
      setService(found);
    }
  }, [services, slug]);

  return (
    <Box
      sx={{
        bgcolor: "secondary.main",
        color: "primary.main",
        py: 4,
        textAlign: "center",
      }}
    >
      <Container maxWidth="xl">
        {/* ---------- HEADER ---------- */}
        {service && (
          <Helmet>
            <link
              rel="canonical"
              href={`https://www.dendenclaw.com/explore/${service.slug}`}
            />
          </Helmet>
        )}

        {/* ---------- CONTENT ---------- */}
        {service && (
          <Grid container spacing={3} justifyContent="center">
            <Grid item xs={12}>
              <Card
                sx={{
                  mx: "auto",
                  maxWidth: 1200,
                  borderRadius: 3,
                  overflow: "hidden",
                  transition: "0.3s ease",
                  "&:hover": {
                    boxShadow: 10,
                  },
                }}
              >
                {/* No CardActionArea wrapper: it renders a <button>, and
                    nesting interactive service content (e.g. the Pop-Ups
                    booking calendar) inside a button swallows their clicks. */}
                <>
                  <CardMedia
                    component="img"
                    height="520"
                    image={service.service_img}
                    srcSet={service.service_img_srcset}
                    sizes={service.service_img_sizes}
                    loading="eager"
                    decoding="async"
                    fetchPriority="high"
                    alt={service.treatment}
                  />

                  <CardContent sx={{ textAlign: "left", px: { xs: 2, md: 4 } }}>
                    {ServiceComponent ? (
                      <Suspense
                        fallback={
                          <Box sx={{ textAlign: "center", py: 6 }}>
                            <CircularProgress />
                          </Box>
                        }
                      >
                        <ServiceComponent />
                      </Suspense>
                    ) : (
                      <Typography>No content available.</Typography>
                    )}
                  </CardContent>
                </>
              </Card>
            </Grid>
          </Grid>
        )}

        {/* ---------- CTA ---------- */}
        <Box sx={{ mt: 6 }}>
          <HashLink smooth to="/services#services" className="text-style">
            <Button
              variant="contained"
              color="primary"
              startIcon={<ArrowBackRoundedIcon />}
              sx={{
                px: 4,
                py: 1.2,
                fontWeight: 600,
                textTransform: "none",
              }}
            >
              Back to Services
            </Button>
          </HashLink>
        </Box>
      </Container>
    </Box>
  );
};

export default ServiceDetails;
